import { ApiError } from "./ApiError";
import { type ApiErrorBody, isApiErrorCode } from "./apiErrorCodes";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const readJson = async (response: Response): Promise<unknown> => {
  try {
    return JSON.parse(await response.clone().text()) as unknown;
  } catch {
    return null;
  }
};

// Ответ не из 2xx → `ApiError`. Тело бэкенда — `{"error": "<код>", "params": {...}}`.
// Код не из контракта или не-JSON (502 от nginx) — `ApiError` с кодом `unknown`.
export const parseApiError = async (response: Response): Promise<ApiError> => {
  const json = await readJson(response);
  const rawCode = isRecord(json) && typeof json.error === "string" ? json.error : null;
  if (!isRecord(json) || !isApiErrorCode(rawCode)) {
    return new ApiError({ status: response.status, body: null, rawCode });
  }
  // Форму `params` не проверяем: её гарантирует Pydantic на бэкенде, а типы — генерация.
  const params = isRecord(json.params) ? json.params : {};
  const body = { error: rawCode, params } as ApiErrorBody;
  return new ApiError({ status: response.status, body, rawCode });
};
